import React from 'react';
import FletesLiquidaciones from '../../components/fletes/FletesLiquidaciones';
import { PageWrapper } from '../../components/common';

const ListarLiquidacionesFletes: React.FC = () => {
  return (
    <PageWrapper>
      <FletesLiquidaciones />
    </PageWrapper>
  );
};

export default ListarLiquidacionesFletes;